import { combineReducers } from 'redux';

import * as actionTypes from '@store/orders/action-types';

const getDefaultQuotes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_DEFAULT_QUOTES_FAILURE:
			return state;
		case actionTypes.FETCH_DEFAULT_QUOTES_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getInvoiceDetails = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_PI_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_PI_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getBrandLocaionList = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BRAND_LOCATION_LIST_FAILURE:
			return state;
		case actionTypes.FETCH_BRAND_LOCATION_LIST_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getBeneficiaryList = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_BENEFICIARY_ALL_FAILURE:
			return state;
		case actionTypes.FETCH_BENEFICIARY_ALL_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getNitexBankDetails = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_NITEX_BANK_DETAILS_FAILURE:
			return state;
		case actionTypes.FETCH_NITEX_BANK_DETAILS_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getOrderPlaceWorkflow = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ORDER_PLACE_WORKFLOW_FAILURE:
			return state;
		case actionTypes.FETCH_ORDER_PLACE_WORKFLOW_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getOrderDetailsInfo = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ORDER_DETAILS_INFO_FAILURE:
			return state;
		case actionTypes.FETCH_ORDER_DETAILS_INFO_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const getAllUsersByTypes = (state = [], { type, payload }) => {
	switch (type) {
		case actionTypes.FETCH_ALL_USERS_BY_TYPES_FAILURE:
			return state;
		case actionTypes.FETCH_ALL_USERS_BY_TYPES_SUCCESS:
			return payload;
		default:
			return state;
	}
};

const orderReducer = combineReducers({
	defaultQuotes: getDefaultQuotes,
	invoiceDetails: getInvoiceDetails,
	brandLocationList: getBrandLocaionList,
	beneficiaryList: getBeneficiaryList,
	nitexBankDetails: getNitexBankDetails,
	orderPlaceWorkFlow: getOrderPlaceWorkflow,
	orderDetailsInfo: getOrderDetailsInfo,
	alllUsersByTypes: getAllUsersByTypes
});

export default orderReducer;
